<template>
  <div>
    <div class="router-content page-right-header">
      <vs-button color="primary" type="filled" @click="showAddEditDialog = true"
        >Add Memo</vs-button
      >
    </div>
    <vs-popup
      fullscreen
      class="holamundo digitelex-popup"
      :title="modalTitle"
      :active.sync="showAddEditDialog"
    >
      <addEditMemo
        :frmData="currentEditRow ? currentEditRow : formData"
        :onlyAddConsignments="addOnlyConsignments"
        v-if="showAddEditDialog"
        @submitResponse="reloadData"
      ></addEditMemo>
    </vs-popup>
    <div id="ag-grid-demo">
      <vx-card>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="
                  p-4
                  border border-solid
                  d-theme-border-grey-light
                  rounded-full
                  d-theme-dark-bg
                  cursor-pointer
                  flex
                  items-center
                  justify-between
                  font-medium
                "
              >
                <span class="mr-2">
                  {{
                    currentPage * paginationPageSize - (paginationPageSize - 1)
                  }}
                  -
                  {{
                    memos.length - currentPage * paginationPageSize > 0
                      ? currentPage * paginationPageSize
                      : memos.length
                  }}
                  of {{ memos.length }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                  <span>150</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div
            class="
              flex flex-wrap
              items-center
              justify-between
              ag-grid-table-actions-right
            "
          >
            <vs-input
              class="mb-4 md:mb-0 mr-4"
              v-model="searchQuery"
              @input="updateSearchQuery"
              placeholder="Search..."
            />
            <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()"
              >Export as CSV</vs-button
            >
          </div>
        </div>
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="memos"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :context="context"
          :tooltipShowDelay="'0'"
          :overlayLoadingTemplate="overlayLoadingTemplate"
          :overlayNoRowsTemplate="overlayNoRowsTemplate"
        ></ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { EventBus } from "./../../../utils/grid/eventbus.js";
import addEditMemo from "./add-edit-memo";

// define cellRenderer to be reused
//  @close="close" -> For popup props
let actionsTemplate = {
  template: `<div class="flex">
    <vx-tooltip text="Stop Vehicle" position="top" v-if="params.data.tripFlag == 2 && params.data.toBranchId == branchId">
      <img class="travelling" @click="updateTripStatus"/>
   </vx-tooltip>
   <vx-tooltip text="Vehicle Reached Desitination" position="right" v-if="params.data.tripFlag == 3">
      <img class="reachedVehicle" />
   </vx-tooltip>
   <vx-tooltip text="Add Consignments" position="top"  >
<vs-button class="w-1/2 flex"  v-if="params.data.tripFlag <=2" @click="addConsignmentsOnly" size="medium" radius color="primary" type="flat" icon-pack="feather" icon="icon-plus"></vs-button>
  </vx-tooltip>
   <vx-tooltip text="Edit" position="top"  >
<vs-button class="w-1/2"  @click="editMemo" v-if="params.data.tripFlag != 3" size="medium" radius color="primary" type="flat" icon-pack="feather" icon="icon-edit"></vs-button>
  </vx-tooltip>
   <vx-tooltip text="Delete" position="top"  >
<vs-button class="w-1/2" @click="deleteMemo" v-if="params.data.tripFlag != 3"  size="medium" radius color="danger" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
  </vx-tooltip>
    </div>`,
  data() {
    return {
      branchId: JSON.parse(localStorage.getItem("sstUnData")).branchId
    };
  },
  methods: {
    editMemo() {
      EventBus.$emit("editMemo", { item: this.params });
    },
    updateTripStatus() {
      EventBus.$emit("updateTripStatus", { item: this.params });
    },
    deleteMemo() {
      EventBus.$emit("deleteMemo", { item: this.params });
    },
    addConsignmentsOnly() {
      EventBus.$emit("addConsignmentsOnly", { item: this.params });
    }
  },
  beforeMount() {}
};
let printTemplate = {
  template: `<div class="flex">
   <vx-tooltip text="Print Memo" position="top"  >
<vs-button class="w-1/2 flex"  @click="showMemo" size="medium" radius color="primary" type="flat" icon-pack="material-icons" icon="text_snippet"></vs-button>
  </vx-tooltip>
   <vx-tooltip text="Print Lorry Receipt" position="top"  >
<vs-button class="w-1/2"  @click="showLorryReceipt"   size="medium" radius color="primary" type="flat" icon-pack="material-icons" icon="integration_instructions"></vs-button>
  </vx-tooltip> 
  <vx-tooltip text="Cash Memo" position="top"  >
<vs-button class="w-1/2"  @click="showLorryReceiptWithAmount"  v-if="sessionRoleId==1 || sessionRoleId==2"  size="medium" radius color="primary" type="flat" icon-pack="material-icons" icon="ballot"></vs-button>
  </vx-tooltip> 
    </div>`,
  data() {
    return {
      sessionRoleId: JSON.parse(localStorage.getItem("sstUnData")).roles[0]
        .roleId
    };
  },
  methods: {
    showMemo() {
      EventBus.$emit("showMemo", { item: this.params });
    },
    showLorryReceipt() {
      EventBus.$emit("showLorryReceipt", { item: this.params });
    },
    showLorryReceiptWithAmount() {
      EventBus.$emit("showLorryReceiptWithAmount", { item: this.params });
    }
  },
  beforeMount() {}
};
export default {
  components: {
    "ag-grid-vue": AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    actionsTemplate: actionsTemplate,
    addEditMemo: addEditMemo,
    // eslint-disable-next-line vue/no-unused-components
    printTemplate: printTemplate
  },
  beforeMount() {
    // this.gridApi.showLoadingOverlay();
    this.overlayLoadingTemplate =
      '<span class="ag-overlay-loading-center">Please wait while loading Memos</span>';
    this.overlayNoRowsTemplate =
      '<span class="ag-overlay-loading-center">No Memos found!</span>';
    this.context = {
      componentParent: this
    };
  },
  data() {
    return {
      showAddEditDialog: false,
      currentEditRow: null,
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      context: null,
      addOnlyConsignments: false,
      modalTitle: "Add Memo",
      formData: {
        isActive: true,
        tripId: null,
        tripFlag: null,
        pVehicleId: null,
        vehicleNo: null,
        fromBranchId: 0,
        toBranchId: 0,
        vehicleOwnerName: null,
        tripDriveName: "",
        tripDriverMobileNo: null,
        tripDriverdlr: null,
        vehicleOwnerGstNo: null,
        tripBookedDate: null,
        VehicleChassisNo: null,
        tripEngagedThrough: null,
        tripRanger: null,
        tripFreightCharges: 0,
        tripAdvancePaid: 0,
        tripOtherCharges: 0,
        tripPayableBy: null,
        consignmentsList: []
      },
      overlayLoadingTemplate: null,
      overlayNoRowsTemplate: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "Actions",
          width: 180,
          filter: false,
          pinned: "left",
          cellRendererFramework: "actionsTemplate"
        },
        {
          headerName: "Print",
          width: 120,
          filter: false,
          pinned: "left",
          cellRendererFramework: "printTemplate"
        },
        {
          headerName: "Memo No",
          field: "tripId",
          width: 120,
          filter: true,
          tooltipField: "tripId",
          pinned: "left",
          valueFormatter: _params => {
            return `${_params.data.tripId}/${_params.data.fromShortName}`;
          }
        },
        {
          headerName: "Status",
          field: "tripFlag",
          width: 150,
          filter: true,
          tooltipField: "tripFlag",
          pinned: "left",
          valueFormatter: _params => {
            if (_params.value === 1) {
              return "Trip Added";
            } else if (_params.value === 2) {
              return "Trip Started";
            } else if (_params.value === 3) {
              return "Vechicle Reached";
            }
          }
        },
        {
          headerName: "Vehicle No",
          headerTooltip: "Vehicle No",
          field: "VehicleNo",
          filter: true,
          width: 140,
          tooltipField: "VehicleNo"
        },
        {
          headerName: "From Location",
          headerTooltip: "From Location",
          field: "fromBranchName",
          filter: true,
          width: 200,
          tooltipField: "fromBranchName"
        },
        {
          headerName: "To Location",
          field: "toBranchName",
          headerTooltip: "To Location",
          filter: true,
          width: 200,
          tooltipField: "toBranchName"
        },
        {
          headerName: "Trip Date",
          headerTooltip: "Trip Date",
          field: "tripBookedDate",
          filter: true,
          width: 180,
          tooltipField: "tripBookedDate"
        },
        {
          headerName: "Driver Name",
          headerTooltip: "Driver Name",
          field: "tripDriveName",
          filter: true,
          width: 180,
          tooltipField: "tripDriveName"
        },
        {
          headerName: "Driver Mobile No",
          headerTooltip: "Driver Mobile No",
          field: "tripDriverMobileNo",
          filter: true,
          width: 180,
          tooltipField: "tripDriverMobileNo"
        },
        {
          headerName: "Vehicle Owner Name",
          headerTooltip: "Vehicle Owner Name",
          field: "vehicleOwnerName",
          filter: true,
          width: 250,
          tooltipField: "vehicleOwnerName"
        }
      ],
      memos: [],
      // pdfUrl: "http://localhost:8081/transport-System/PDF/views/new/",
      pdfUrl: "https://newpdf.srisainadhtransport.in/2025/"
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("vehicleNo", null);
      } else this.gridOptions.columnApi.setColumnPinned("vehicleNo", "left");
    },
    showAddEditDialog: function() {
      Object.keys(this.formData).forEach(key => {
        if (typeof key === "string") this.formData[key] = "";
        else if (typeof key === "boolean") this.formData[key] = false;
        else if (typeof key === "number") this.formData[key] = 0;
        else this.formData[key] = "";
      });
      if (!this.showAddEditDialog) {
        this.currentEditRow = false;
      }
      this.formData.fromBranchId = JSON.parse(
        localStorage.getItem("sstUnData")
      ).branchId;
    }
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    reloadData(_event) {
      this.showAddEditDialog = false;
      this.addOnlyConsignments = false;
      this.memos = _event.data.data;
      this.$vs.notify({
        title: _event.data.message,
        color: "success",
        position: "top-right"
      });
      this.gridApi.setRowData(_event.data.data);
    },
    deleteMemo(_e) {
      this.$http
        .put("portage/memo", _e.data)
        .then(response => {
          // text:'Lorem ipsum dolor sit amet, consectetur',

          this.$vs.notify({
            title: response.data.message,
            color: "success",
            position: "top-right"
          });
          this.gridApi.setRowData(response.data.data);
          // this.$emit("submitResponse", response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.showLoadingOverlay();
    this.$http.get("portage/memos").then(response => {
      if (response.data.data.length > 0) {
        this.gridApi.hideOverlay();
        this.allMemos = response.data.data;
        this.memos = response.data.data;
      } else {
        this.gridApi.showNoRowsOverlay();
      }
    });
    EventBus.$on("editMemo", memoData => {
      this.onlyAddConsignments = false;
      this.currentEditRow = memoData.item.data;
      this.showAddEditDialog = true;
    });

    EventBus.$on("updateTripStatus", memoData => {
      console.log(memoData);
      this.$http
        .put("portage/updateTripStatus", memoData.item.data)
        .then(response => {
          // text:'Lorem ipsum dolor sit amet, consectetur',
          this.$vs.notify({
            title: response.data.message,
            color: "success",
            position: "top-right"
          });
          this.gridApi.setRowData(response.data.data);
          // this.$emit("submitResponse", response);
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right"
          });
          // console.log();
        });

      // this.showAddEditDialog = true;
    });
    EventBus.$on("addConsignmentsOnly", memoData => {
      this.addOnlyConsignments = true;
      this.currentEditRow = memoData.item.data;

      this.showAddEditDialog = true;
      console.log(memoData);
      // this.showAddEditDialog = true;
    });

    EventBus.$on("showMemo", memoData => {
      const url =
        this.pdfUrl +
        "memopdf.php?memoid=" +
        btoa(memoData.item.data.tripId) +
        "&token=" +
        localStorage.getItem("sessionToken");
      // alert(url);
      window.open(url, "_blank");
      return false;
    });

    EventBus.$on("showLorryReceipt", memoData => {
      const url =
        this.pdfUrl +
        "lorryreceiptpdf.php?memoid=" +
        btoa(memoData.item.data.tripId) +
        "&token=" +
        localStorage.getItem("sessionToken");
      // alert(url);
      window.open(url, "_blank");
      return false;
    });

    EventBus.$on("showLorryReceiptWithAmount", memoData => {
      const url =
        this.pdfUrl +
        "memopdfwithamount.php?memoid=" +
        btoa(memoData.item.data.tripId) +
        "&token=" +
        localStorage.getItem("sessionToken");
      // alert(url);
      window.open(url, "_blank");
      return false;
    });

    EventBus.$on("deleteMemo", memoData => {
      // this.currentEditRow = clientData.item.data;
      let rowData = memoData;
      rowData.item.data.isActive = false;
      console.log(memoData);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Memo?`,
        text: ``,
        acceptText: "Accept!",
        accept: this.deleteMemo,
        parameters: rowData.item
      });
      setTimeout(() => {
        if (document.getElementsByClassName("vs-dialog-text").length > 0) {
          document.getElementsByClassName(
            "vs-dialog-text"
          )[0].innerHTML = `Do you want to delete below Memo?<br/><blockquote>Memo No: <b>${rowData.item.data.tripId}</b></blockquote>`;
        }
      }, 0);
    });
  }
};
</script>
<style scoped>
.digitelex-popup .vs-popup {
  width: 56vw;
}
</style>
<style>
.travelling {
  content: url("./../../../../assets/images/transport/travelling.gif");
  width: 42px;
  height: 42px;
  cursor: pointer;
  border-radius: 50%;
}
.reachedVehicle {
  content: url("./../../../../assets/images/transport/unloaded.png");
  width: 42px;
  height: 42px;
  cursor: pointer;
  border-radius: 50%;
}
</style>
